import {
    REGISTER_SUBMIT_FAILURE,
    REGISTER_SUBMIT_SUCCESS,
    REGISTER_TOGGLE_AGREE_SERVICE_TERMS
} from '../actions/AccountActions';
import {HttpStatus} from '../Constants';
import get from 'lodash/get';
import {addNotification} from '../notifications';

const initialState = {
    agreed: false,
    error: null,
};

export function registration(state = initialState, action) {
    switch (action.type) {
        case REGISTER_TOGGLE_AGREE_SERVICE_TERMS: {
            const {agreed} = state;
            return {...state, agreed: !agreed};
        }
        case REGISTER_SUBMIT_SUCCESS: {
            addNotification({message: 'Your registration was successful. Please login into your new account', level: 'success', position: 'tc'});
            break;
        }
        case REGISTER_SUBMIT_FAILURE: {
            const {error} = action;
            switch (error.status) {
                case HttpStatus.NOT_ACCEPTABLE:
                case HttpStatus.CONFLICT: // Email already has account
                    return {...state, error: 'E-mail is already used'};
                default:
                    return {...state, error: get(error, 'response.body.message', JSON.stringify(error))};
            }
        }
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/registeration.js